<template>
  <div>
    <v-tabs
      :value="filterMode"
      @change="updateFilterMode"
      background-color="transparent"
    >
      <v-tab key="quickFilter" data-cy="listFilter-select-quick"
        >Quick Filter</v-tab
      >

      <v-tab-item eager key="quickFilter" class="tab-item-override">
        <list-filter-quick
          :attribute-list-selected="attributeListSelected"
          :entity-list-formatted="entityListFormatted"
          :filter-mode="filterMode"
          :filter-name="0"
          @update-entity-list-filtered="updateEntityListFiltered"
        ></list-filter-quick>
      </v-tab-item>

      <template v-if="importKeyAttribute">
        <v-tab key="filterByImportKey" data-cy="listFilter-select-importKey"
          >By {{ getLabel(importKeyAttribute) }}</v-tab
        >

        <v-tab-item eager key="filterByImportKey">
          <list-filter-by-import-key
            :entity-list-formatted="entityListFormatted"
            :filter-mode="filterMode"
            :filter-name="1"
            :import-key-attribute="importKeyAttribute"
            @update-entity-list-filtered="updateEntityListFiltered"
          ></list-filter-by-import-key>
        </v-tab-item>
      </template>

      <v-tab key="advancedFilter" data-cy="listFilter-select-advanced"
        >Advanced</v-tab
      >

      <v-tab-item eager key="advancedFilter" class="transparent">
        <list-filter-advanced
          :attribute-list-selected="attributeListSelected"
          :attribute-list-showable="attributeListShowable"
          :entity-list-formatted="entityListFormatted"
          :entity-name="entityName"
          :filter-mode="filterMode"
          :filter-name="2"
          @update-attribute-list-selected="updateAttributeListSelected"
          @update-entity-list-filtered="updateEntityListFiltered"
        ></list-filter-advanced>
      </v-tab-item>
    </v-tabs>

    <v-alert
      v-if="hasFilteredOutSelectedEntities"
      dense
      outlined
      class="mb-8"
      color="warning"
    >
      <template v-slot:append>
        <v-btn
          @click="updateEntityListSelected([])"
          color="warning"
          outlined
          small
          >Deselect all</v-btn
        >
      </template>
      <v-icon color="warning" class="mr-4">fas fa-exclamation-circle</v-icon
      >Some selected {{ entityName }}s are not visible with the current filter.
    </v-alert>
  </div>
</template>

<script>
import { getLabel } from "@/lib/componentUtil";

import ListFilterAdvanced from "./ListFilterAdvanced";
import ListFilterByImportKey from "./ListFilterByImportKey";
import ListFilterQuick from "./ListFilterQuick";

export default {
  components: {
    ListFilterAdvanced,
    ListFilterByImportKey,
    ListFilterQuick,
  },
  computed: {
    hasFilteredOutSelectedEntities() {
      const { entityListFiltered, entityListSelected, idAttributeName } = this;

      const filteredIdList = entityListFiltered.map(
        ({ [idAttributeName]: id }) => id
      );

      const selectedIdList = entityListSelected.map(
        ({ [idAttributeName]: id }) => id
      );

      return !selectedIdList.every(selectedId =>
        filteredIdList.includes(selectedId)
      );
    },
  },
  created() {
    const { entityListFormatted } = this;

    // Init to entity list formatted
    this.updateEntityListFiltered(entityListFormatted);
  },
  methods: {
    addAdvancedColumns() {
      let { search } = this;
      if (!Array.isArray(search) || !search.length || !search[0].attribute) {
        return;
      }

      this.headerOptionListSelected = this.headerOptionListSelected.concat(
        search
          .filter(({ attribute }) => {
            return this.headerOptionListSelected.every(
              ({ value }) => attribute.name != value
            );
          })
          .map(filter => {
            return this.headerOptionList.find(
              header => header.value === filter.attribute.name
            );
          })
      );
    },
    advancedSearchFilter(entity, search) {
      if (!search) {
        return true;
      }

      return search.every(filter => {
        const entityValue = `${entity[filter.attribute.name]}`.toLowerCase();
        return filter.valueList.every(value => {
          if (filter.operator === "Equals") {
            if (entityValue == `${value}`.toLowerCase()) {
              return true;
            }
          }
          if (filter.operator === "Does not equal") {
            if (entityValue != `${value}`.toLowerCase()) {
              return true;
            }
          }
          if (filter.operator === "Contains") {
            try {
              if (
                entityValue &&
                entityValue.includes(`${value}`.toLowerCase())
              ) {
                return true;
              }
            } catch {
              return false;
            }
          }
          if (filter.operator === "Does not contain") {
            try {
              if (!entityValue.includes(`${value}`.toLowerCase())) {
                return true;
              }
            } catch {
              return true;
            }
          }
          return false;
        });
      });
    },
    getLabel,
    updateAttributeListSelected(updatedAttributeListSelected) {
      this.$emit(
        "update-attribute-list-selected",
        updatedAttributeListSelected
      );
    },
    updateEntityListFiltered(updatedEntityListFiltered) {
      this.$emit("update-entity-list-filtered", updatedEntityListFiltered);
    },
    updateEntityListSelected(updatedEntityListSelected) {
      this.$emit("update-entity-list-selected", updatedEntityListSelected);
    },
    updateFilterMode(updatedFilterMode) {
      const {
        $route: { path },
        filterMode,
      } = this;

      if (filterMode === updatedFilterMode) {
        return;
      }

      this.$router.replace({ path, query: { filterMode: updatedFilterMode } });
    },
  },
  props: {
    attributeListSelected: {
      required: true,
      type: Array,
    },
    attributeListShowable: {
      required: true,
      type: Array,
    },
    entityListFiltered: {
      required: true,
      type: Array,
    },
    entityListFormatted: {
      required: true,
      type: Array,
    },
    entityListSelected: {
      required: true,
      type: Array,
    },
    entityName: {
      required: true,
      type: String,
    },
    filterMode: {
      default: "quickFilter",
    },
    idAttributeName: {
      required: true,
      type: String,
    },
    importKeyAttribute: {},
  },
};
</script>
